import React from 'react'
import { getHomepageContent } from '../src/utils/contentful'
import { useRouter } from 'next/router'
import { renderComponent } from '../src/utils/components'
import { Layout } from '../src/components'
import { getSiteAlternateUrl } from '../build-helpers/utils'
import { useGlobalData } from './_app'
import { getMarketHeader } from '@/build-helpers/market'
import ErrorBoundary from '@/src/components/errorBoundary/ErrorBoundary'
import { availableLocales } from '@/src/helpers/availableLocales'

export async function getStaticProps({ locale }) {
  try {
    // Ignore default locale
    if (locale === 'default' || !availableLocales.includes(locale)) {
      return {
        notFound: true
      }
    }
    const slugPrefix = locale

    const language = locale.split('-')[0]

    const pageContent = await getHomepageContent(language, slugPrefix)

    if (!pageContent) {
      return {
        notFound: true
      }
    }

    const pageContext = await getMarketHeader(language, slugPrefix)

    if (!pageContext || !pageContext.market?.id) {
      return {
        notFound: true
      }
    }

    return {
      props: {
        locale: language,
        slugPrefix,
        page: pageContent,
        header: pageContext?.header,
        market: pageContext?.market,
        footer: pageContext?.footer
      }
    }
  } catch (error) {
    console.error('Error in getStaticProps for index page:', error)
    return {
      notFound: true
    }
  }
}

const HomePage = ({ slugPrefix, locale, page }) => {
  const router = useRouter()
  const globalData = useGlobalData()
  const markets = globalData?.markets || []
  const alternateUrls =
    markets
      .map((market) => {
        const marketLocales = market.locales.map((locale) => {
          return {
            rel: 'alternate',
            hrefLang: locale,
            href: getSiteAlternateUrl(locale)
          }
        })
        return marketLocales
      })
      .flat() || []

  const { title, metaImage, metaTags, marketsMetaTags, components } = page

  const newComponents = Array.isArray(components) ? components : []
  if (router.isFallback) {
    return <div>Loading...</div>
  }

  return (
    <ErrorBoundary>
      <Layout
        seoData={{
          title: title,
          marketsMetaTags: marketsMetaTags,
          metaTags: metaTags,
          metaImage: metaImage,
          alternate: alternateUrls,
          pageType: 'page'
        }}
        slugPrefix={slugPrefix}
        allMarkets={globalData?.markets}
      >
        {newComponents?.map((component, idx) =>
          renderComponent({
            component,
            extra: {
              locale,
              slugPrefix
            },
            idx
          })
        )}
      </Layout>
    </ErrorBoundary>
  )
}

export default HomePage
